export default {"src":"/pro/_next/static/media/comp.9f2d0521.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};